<div class="content">

  <div class="header">{{ 'bikeshop.rentals.configuration.custom_pickup_slots' | translate }}</div>

  <div class="row margin-top-16">
    <div class="col-md-6 label" style="margin-top: 0px;"
      [ngClass]="{invalid: !(data.dayOfWeek >= 0 && data.dayOfWeek < 7)}">{{
      'bikeshop.rentals.configuration.select_day' | translate }}
    </div>
    <div class="col-md-6 days">
      <div *ngFor="let day of days">
        <div *ngIf="!data.id || data.dayOfWeek === day">
          <div>
            <p-radioButton name="DayOfTheWeek" [value]="day" [(ngModel)]="data.dayOfWeek"
              [disabled]="data.id || !isDayValid(day)" (click)="dayChanged()">
            </p-radioButton>
          </div>
          <div class="label">{{ dayOfWeek(day) }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-6 label"
      [ngClass]="{invalid: !data.pickupTime || data.pickupTime < getMinDate() || data.pickupTime > getMaxDate()}">{{
      'bikeshop.rentals.booking.pickup_time' | translate }}</div>
    <div class="col-md-6">
      <div style="width: 100%">
        <p-calendar [(ngModel)]="data.pickupTime" [readonlyInput]="true" [disabled]="data.dayOfWeek === null || data.dayOfWeek === undefined"
          [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly">
        </p-calendar>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-6 label"></div>
    <div class="col-md-6">
      <div class="small" *ngIf="data.pickupTime && (data.pickupTime < getMinDate() || data.pickupTime > getMaxDate())">
        {{'bikeshop.rentals.configuration.pickup_time_message' | translate : {start: getMinDate(true), end:
        getMaxDate(true)} }}</div>
    </div>
  </div>

  <div class="margin-top-16">
    <div class="row">
      <div class="col-md-8 label"></div>
      <div class="col-md-4">
        <button pButton (click)="save()" class="p-button-raised full-width p-mini" [ngClass]="{'busy': saving}"
          label="{{ (saving ? 'bikeshop.general.busy' : data.id ? 'bikeshop.general.update' : 'bikeshop.general.save') | translate}}"
          [disabled]="saving || !valid()"></button>
      </div>
    </div>
  </div>
